<template>
  <div>
    <div class="auth" :class="{'is-dark': dark}">
      <h1 class="auth-heading">{{title}}</h1>
      <h2 class="auth-subheading">{{description}}</h2>
      <br/>
      <div class="auth__error" v-if="error">{{error}}</div>
      <form class="auth-form" action="#" @submit.prevent="submit">
        <ff-input
          placeholder="Email"
          data-test="email"
          type="email"
          class="auth-input"
          name="email"
          :ref="'emailInput'"
          value
          required
          autofocus
          v-model="form.email"
        />
        <ff-input
          placeholder="Password"
          data-test="password"
          type="password"
          class="auth-input"
          name="password"
          required
          v-model="form.password"
        />
        <br/>
        <ff-button
          data-test="email-submit"
          type="submit"
          :text="'Sign In / Sign Up'"
          :action="submit"
        />
        <aside data-test="password-reset" class="auth-form__reset" v-if="hasEmail && !reset" @click="resetPassword">
          Forgot your password? Click here to reset it.
        </aside>
        <aside data-test="password-reset--empty" class="auth-form__reset" v-if="!hasEmail && !reset">
          Forgot your password? Please enter your email.
        </aside>
        <aside data-test="reset-confirmation" class="auth-form__reset--complete" v-if="reset">
          Your password has been reset! Please check your email, then return to this page to Sign In.
        </aside>
      </form>
      <aside class="auth-aside">Already a user? Don't have an account? Just sign in above, and we'll take care of it. By signing up, you agree to our <a href="/terms" target="_blank">Terms</a> and <a href="/privacy" target="_blank">Privacy Policy</a>.</aside>
    </div>
  </div>
</template>

<script>
import { createUser, auth } from '../../helpers/firebase'
import { mapState } from 'vuex'

import FFButton from '../DesignSystem/FFButton'
import FFInput from '../DesignSystem/FFInput'

export default {
  name: 'Auth',
  components: {
    'ff-button': FFButton,
    'ff-input': FFInput
  },
  props: [
    'title',
    'description',
    'dark',
  ],
  data () {
    return {
      error: '',
      reset: false,
      form: {
        email: '',
        password: ''
      }
    }
  },
  computed: {
    ...mapState(['user', 'channel']),
    hasEmail () {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(this.form.email).toLowerCase())
    }
  },
  methods: {
    submit () {
      createUser(this.form.email, this.form.password, this.handleCallback)
    },
    handleCallback (data) {
      if (data.error) this.error = data.error
      if (data.success && !data.error) return this.$emit('callback', data)
    },
    resetPassword () {
      if (!this.hasEmail) {
        this.error = 'Please enter a valid email.'
      }
      let self = this
      auth.sendPasswordResetEmail(this.form.email).then(function() {
        self.reset = true
      }).catch(function(error) {
        console.log(error)
        self.error = 'An error occurred resetting your password, please try again.'
      })
    }
  },
  created () {
    if (this.user) {
      this.$emit('callback', this.user)
    }
  },
  mounted () {
    if (this.$route.query.email) {
      return this.$modal.show('email')
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";

  .auth {
    @include container;
    padding: $unit-3;

    &.is-dark {
      .auth-heading,
      .auth-subheading,
      .auth-aside {
        color: $color-white;
      }
    }
  }

  .auth-heading {
    @include text('heading');
  }

  .auth-subheading {
    @include text('body');
  }

  .auth-aside {
    @include text('aside');
  }

  .auth-form {
    margin: auto;
    padding-right: $unit-2;
    box-sizing: border-box;
  }

  .auth__error {
    @include error;
  }

  .auth-form__reset {
    @include text;
    padding: $unit-1 0;

    &:hover {
      cursor: pointer;
      color: $color-main;
    }
  }

  .auth-form__reset--complete {
    @include text;
    padding: $unit-1 0;
  }

  @import "../../assets/styles/mobile.scss";

</style>
